// Header.jsx
import React from "react";
import { FiUser, FiLogOut } from "react-icons/fi";
import "./Header.css";
import AccountDropdown from "./AccountDropdown";

const Header = ({ isExpanded, onLogout, pageTitle, darkMode, toggleDarkMode, currentUser }) => {

  const dropdownItems = [
    { 
      label: darkMode ? "Light mode" : "Dark mode", 
      onClick: toggleDarkMode,
      icon: darkMode ? "☀️" : "🌙"
    },
    { 
      label: "Logout", 
      onClick: onLogout, 
      dangerous: true,
      icon: <FiLogOut />
    }
  ];

  return (
    <div className={`header ${isExpanded ? "expanded" : ""}`}>
      <h4>{pageTitle}</h4>
      <div className="profile">
        <AccountDropdown items={dropdownItems}>
          <button className="logout-button" title="Account">
            {currentUser?.profile_picture ? (
              <img 
                src={currentUser.profile_picture} 
                alt="Profile" 
                className="profile-picture"
              />
            ) : (
              <FiUser className="profile-icon" />
            )}
          </button>
        </AccountDropdown>
      </div>
    </div>
  );
};

export default Header;
